import { Link } from "react-router-dom";

import styled from "styled-components";

import Button from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import Image from "components/atoms/Image";
import Tooltip from "components/atoms/Tooltip";

import PDFChatTitleInput from "components/organisms/review/PDFChatTitleInput";

import { useDevice } from "utils/device";

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    min-width: 768px;
    height: 56px;
    background-color: var(--color-White);
    border-bottom: solid 1px var(--color-Line);
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
`;

const DivideLine = styled.div`
    margin: 0 12px 0 6px;
    height: 20px;
    border-right: solid 1px #e6e6e6;
`;

const TitleSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px;
    max-width: calc(100% - 480px);
`;

function PDFChatPageHeader(props) {
    const device = useDevice();

    return (
        <Container device={device}>
            <Link as={Link} to={props.reference ? "/reference" : "/"} reloadDocument>
                <Image name={"headerLogo"} />
            </Link>
            <TitleSection>
                <form>
                    <PDFChatTitleInput
                        bibliography={props.reference}
                        bibliographyMutation={props.bibliographyMutation}
                    />
                </form>
            </TitleSection>
            <RightSection>
                <DivideLine />
                <Tooltip message={"나가기"}>
                    <Button
                        onlyIcon
                        size={"32px"}
                        bgColor={"var(--color-Button2)"}
                        hoverBgColor={"var(--color-ButtonHover2)"}
                        fontColor={"var(--color-White)"}
                        onClick={window.close}
                    >
                        <Icon name={"logout"} size={"12"} color={"var(--color-White)"} />
                    </Button>
                </Tooltip>
            </RightSection>
        </Container>
    );
}

export default PDFChatPageHeader;
